
/**
 * Format seconds to a human-readable time string (MM:SS)
 * @param seconds - The time in seconds to format
 * @returns A formatted time string (e.g., "01:30" for 90 seconds)
 */
export const formatTime = (seconds: number): string => {
  if (!seconds || isNaN(seconds)) return '00:00';
  
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  
  const minutesStr = minutes < 10 ? `0${minutes}` : `${minutes}`;
  const secondsStr = remainingSeconds < 10 ? `0${remainingSeconds}` : `${remainingSeconds}`;
  
  return `${minutesStr}:${secondsStr}`;
};
